import { render, staticRenderFns } from "./notification-list-item.vue?vue&type=template&id=c0855048&scoped=true"
import script from "./notification-list-item.vue?vue&type=script&lang=js"
export * from "./notification-list-item.vue?vue&type=script&lang=js"
import style0 from "./notification-list-item.vue?vue&type=style&index=0&id=c0855048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0855048",
  null
  
)

export default component.exports